<template>
    <ion-page>
        <ion-header>
            <ion-toolbar color="primary">
                <ion-buttons slot="start">
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>

                <ion-title>{{ $t('report_sheets.main_page.screen_title') }}</ion-title>

                <ion-buttons slot="secondary">
                    <ion-button @click="reload()">
                        <ion-icon :icon="refreshIcon" />
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>

            <ion-toolbar v-if="is_mobile" color="primary">
                <ion-searchbar
                    v-model="search"
                    :placeholder="$t('report_sheets.main_page.filters.search_placeholder')"
                ></ion-searchbar>
            </ion-toolbar>
        </ion-header>

        <ion-content>
            <ContentSidebarWrapper :class="is_mobile ? $style['custom-height'] : ''" side="left">
                <template v-slot:content>
                    <div v-if="loading">
                        <ReportSheetsSkeleton />
                    </div>
                    <div v-else-if="reportSheets.length">
                        <ion-item v-for="reportSheet in reportSheets" :key="reportSheet.uuid" :sheet="reportSheet" :button="true" @click="$router.push('/report-sheets/' + reportSheet.uuid)">
                            <div :class="$style['inner']">
                                <div>
                                    <h4>{{ reportSheet.title }}</h4>
                                    
                                    <p v-if="reportSheet.total_cost">
                                      {{ $t('report_sheets.main_page.total') }} : {{ reportSheet.total_cost }}€
                                    </p>
                                </div>

                                <div :class="$style['right']">
                                    <p v-show="false" v-if="reportSheet.status == 'pending'">{{ $t('report_sheets.main_page.filters.status.options.pending') }}</p>
                                    <p v-show="false" v-if="reportSheet.status == 'validated'" :class="$style['raport-validated']">{{ $t('report_sheets.main_page.filters.status.options.validated') }}</p>
                                    <p>{{ moment(reportSheet.created_at).format("DD/MM/YYYY") }}</p>

                                    <div :class="$style['user-pictures']">
                                      <img v-for="role in reportSheet.roles" :key="role.user.uuid" :src="role.user.profile_picture??''" loading="lazy" alt="Profile picture"/>
                                    </div>

                                    <ul :class="$style['report-sheet-validation-status']">
                                        <li :class="reportSheet.validated_by_site_supervisor ? $style['validated'] : $style['waiting']">
                                            <span :class="$style['status']" style="display: flex; align-items: center;">
                                                <ion-icon size="small" :icon="reportSheet.validated_by_site_supervisor ? checkmarkCircleOutline : closeCircleOutline"></ion-icon>
                                                <span>Condu.</span>
                                                <span v-show="false">
                                                    {{ $t('users.roles.site-supervisor') }}
                                                </span>
                                            </span>

                                            <span :class="$style['user-initials-wrapper']">
                                                <span v-for="role in reportSheet.roles.filter(r => r.role === 'site-supervisor')" :key="role.user.uuid">
                                                    <img v-if="role.user.profile_picture" :src="role.user.profile_picture" alt="Profile picture" :class="$style['role-user-picture']" />
                                                </span>
                                            </span>
                                        </li>

                                        <li :class="reportSheet.validated_by_site_manager ? $style['validated'] : $style['waiting']">
                                            <span :class="$style['status']" style="display: flex; align-items: center;">
                                                <ion-icon size="small" :icon="reportSheet.validated_by_site_manager ? checkmarkCircleOutline : closeCircleOutline"></ion-icon>
                                                <span>CE</span>
                                                <span v-show="false">
                                                    {{ $t('users.roles.site-manager') }}
                                                </span>
                                            </span>

                                            <span :class="$style['user-initials-wrapper']">
                                                <span v-for="role in reportSheet.roles.filter(r => r.role === 'site-manager')" :key="role.user.uuid">
                                                    <img v-if="role.user.profile_picture" :src="role.user.profile_picture" alt="Profile picture" :class="$style['role-user-picture']" />
                                                </span>
                                            </span>
                                        </li>

                                        <li :class="reportSheet.validated_by_manager ? $style['validated'] : $style['waiting']">
                                            <span :class="$style['status']" style="display: flex; align-items: center;">
                                                <ion-icon size="small" :icon="reportSheet.validated_by_manager ? checkmarkCircleOutline : closeCircleOutline"></ion-icon>
                                                <span>CDG</span>
                                                <span v-show="false">
                                                    {{ $t('users.roles.manager') }}
                                                </span>
                                            </span>

                                            <span :class="$style['user-initials-wrapper']">
                                                <span v-for="role in reportSheet.roles.filter(r => r.role === 'manager')" :key="role.user.uuid">
                                                    <img v-if="role.user.profile_picture" :src="role.user.profile_picture" alt="Profile picture" :class="$style['role-user-picture']" />
                                                </span>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ion-item>

                        <ion-infinite-scroll
                            id="infinite-scroll"
                            threshold="500px"
                            @ionInfinite="loadNextPage($event)"
                        >
                            <ion-infinite-scroll-content></ion-infinite-scroll-content>
                        </ion-infinite-scroll>
                    </div>
                    <div v-else>
                        <ion-text class="ion-text-center" color="medium">
                            <p>{{ $t('report_sheets.main_page.no_result') }}</p>
                        </ion-text>
                    </div>
                </template>

                <template v-slot:sidebar>
                    <div :class="$style['filters-content']">
                        <div
                            v-if="!is_mobile"
                            :class="$style['filter-item-wrapper']"
                            class=""
                        >
                            <ion-searchbar
                                v-model="search"
                                :class="$style['filter-item-search']"
                                :placeholder="$t('report_sheets.main_page.filters.search_placeholder')"
                                color="light"
                                mode="ios"
                            ></ion-searchbar>
                        </div>

                        <div :class="$style['filter-item-wrapper']">
                            <div :class="$style['filter-item']">
                                <ion-button
                                    color="light"
                                    expand="full"
                                    @click="open_site_selector = true"
                                >
                                    <div :class="$style['button-inner']">
                                        <ion-icon :icon="mapIcon" color="medium" />
                                        <ion-text v-if="!site?.name" color="medium">
                                        {{ $t("orders.filters.site") }}
                                        </ion-text>

                                        <span v-else>
                                            {{ text.truncate(site?.name, 26) }}

                                            <ion-icon
                                                :class="$style['remove-filter']"
                                                :icon="closeIcon"
                                                color="dark"
                                                @click.stop="site = null"
                                            />
                                        </span>
                                    </div>
                                </ion-button>

                                <SiteSelector
                                    :active="open_site_selector"
                                    @change="site = $event.value"
                                    @close="open_site_selector = false"
                                />
                            </div>
                        </div>

                        <div :class="$style['filter-item-wrapper']">
                            <div :class="$style['filter-item']">
                                <ion-select
                                    v-model="status"
                                    :multiple="true"
                                    :placeholder="$t('report_sheets.main_page.filters.status.label')"
                                    style="width: 100%"
                                >
                                    <ion-select-option value="validated_by_site_supervisor">{{ $t('report_sheets.main_page.filters.status.options.validated_by_site_supervisor') || 'Validated by site supervisor' }}</ion-select-option>
                                    <ion-select-option value="validated_by_site_manager">{{ $t('report_sheets.main_page.filters.status.options.validated_by_site_manager') || 'Validated by site manager' }}</ion-select-option>
                                    <ion-select-option value="validated_by_manager">{{ $t('report_sheets.main_page.filters.status.options.validated_by_manager') || 'Validated by manager' }}</ion-select-option>
                                </ion-select>
                            </div>
                        </div>

                        <div v-if="user.canExportSummaries" :class="$style['filter-item-wrapper']">
                            <div :class="$style['filter-item']">
                                <ion-button
                                    color="primary"
                                    expand="full"
                                    @click="open_export_modal = true"
                                >
                                    <div :class="$style['button-inner']">
                                        <ion-icon :icon="downloadIcon" />
                                        <ion-text>
                                            {{ $t('report_sheets.main_page.export_summaries.button') }}
                                        </ion-text>
                                    </div>
                                </ion-button>

                                <SummariesExportModal
                                    :active="open_export_modal"
                                    :search="search"
                                    :site="site"
                                    :status="status"
                                    @close="open_export_modal = false"
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </ContentSidebarWrapper>
        </ion-content>
    </ion-page>
</template>

<script lang="ts">
    import ContentSidebarWrapper from "@/components/wrappers/ContentSidebarWrapper.vue";
    import ReportSheetsSkeleton from "@/components/skeletons/ReportSheetsSkeleton.vue";
    import { defineAsyncComponent, defineComponent } from "vue"
    import {
        IonButtons,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonPage,
        IonText,
        IonTitle,
        IonSearchbar,
        IonSelect,
        IonSelectOption,
        IonInfiniteScroll,
        IonInfiniteScrollContent,
        IonToolbar,
        InfiniteScrollCustomEvent
    } from "@ionic/vue"
    
    import {
        reload as refreshIcon,
        map as mapIcon,
        closeCircle as closeIcon,
        checkmarkCircleOutline,
        closeCircleOutline,
        downloadOutline as downloadIcon
    } from "ionicons/icons";

    import { ReportSheet } from "@/report-sheets"
    import moment from 'moment';
    import { useUserStore } from "@/stores/user"
    import text from "@/helpers/text";

    import { Site } from "@/sites"
    import {UserRole} from "@/users";
    const SiteSelector = defineAsyncComponent(
        () => import("@/components/data/selectors/SiteSelector.vue")
    )

    const SummariesExportModal = defineAsyncComponent(
        () => import("@/components/data/report-sheets/SummariesExportModal.vue")
    )

    export default defineComponent({
        components: {
            IonTitle, IonToolbar, IonButtons, ReportSheetsSkeleton,
            IonContent, IonText,
            ContentSidebarWrapper, IonPage, IonMenuButton, IonHeader,
            IonSearchbar, IonInfiniteScroll, IonInfiniteScrollContent,
            IonSelect, IonSelectOption, SiteSelector, SummariesExportModal
        },
        setup() {
            const user = useUserStore()

            return {
                moment,
                user,
                refreshIcon,
                mapIcon,
                text,
                closeIcon,
                checkmarkCircleOutline,
                closeCircleOutline,
                downloadIcon
            }
        },
        data() {
            return {
                search: "" as string,
                status: [] as string[],
                search_timeout: null as null | number,
                page: 1,
                loading: false as boolean | false,
                reportSheets: [] as ReportSheet[],
                open_site_selector: false as boolean,
                open_export_modal: false as boolean,
                site: null as Site | null,
            }
        },
        computed: {
            is_mobile() {
                return window?.innerWidth < 768;
            },
        },
        mounted() {
            if (this.user?.is_logged_in)
                this.load(true)

            this.$watch("user.is_logged_in", (is_logged_in: boolean) => {
                if (is_logged_in) {
                    this.setDefaultStatus();
                    this.load(true);
                }
            });
        },
        ionViewWillEnter() {
            if (this.user?.is_logged_in){
                this.setDefaultStatus();
                this.load(true)
            }
        },
        watch: {
            search: function () {
                if (this.search_timeout)
                    clearTimeout(this.search_timeout)

                this.search_timeout = setTimeout(() => {
                    this.load(true)
                }, 750)
            },
            status: function () {
                this.load(true)
            },
            site: function () {
                this.load(true)
            }
        },
        methods: {
            reload() {
                this.search = ""
                this.status = []
                this.site = null
                this.load(true)
            },
            setDefaultStatus() {
                // if (
                //     this.status.length === 0 &&
                //     this.user &&
                //     !this.user.rights.includes('report_sheets.site-supervisor')
                // ) {
                //     this.status = ['validated_by_site_supervisor'];
                // }
            },
            load(refresh = false) {
                if (this.loading)
                    return

                this.loading = true

                if (refresh)
                    this.page = 1

                const statusFilters = this.status.length ? this.status : undefined;

                this.axios.get('/report-sheets', {
                    params: {
                        page: this.page,
                        search: this.search,
                        status: statusFilters,
                        site: this.site?.uuid
                    }
                })
                .then(response => {
                    if (refresh)
                        this.reportSheets = []

                    response.data.data.forEach((reportSheet: ReportSheet) => {
                        this.reportSheets.push(reportSheet)
                    })

                    this.page++
                }).catch(error => {
                    console.error(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            loadNextPage(e: InfiniteScrollCustomEvent) {
                const statusFilters = this.status.length ? this.status : undefined;

                this.axios.get('/report-sheets', {
                    params: {
                        page: this.page,
                        search: this.search,
                        status: statusFilters,
                        site: this.site?.uuid
                    }
                })
                .then(response => {
                    response.data.data.forEach((reportSheet: ReportSheet) => {
                        this.reportSheets.push(reportSheet)
                    })

                    this.page++

                    if (this.page > response.data.last_page)
                        e.target.disabled = true

                    e.target.complete()
                }).catch(error => {
                    console.error(error)
                })
            }
        }
    })
</script>

<style lang="scss" module>
    .filters-content {
        padding-top: 1em;
        padding-bottom: 1em;
    }

    $filter-icon-space: 2.5em;
    $filter-icon-width: 1.4em;

    .filter-item-wrapper {
        padding: 0.25em 1em;

        ion-searchbar,
        ion-button,
        ion-select {
            font-size: 1em !important;
            --box-shadow: none;

            input,
            ion-icon {
            font-size: 1em !important;
            }
        }

        ion-select {
            --padding-start: #{$filter-icon-space};
        }

        ion-searchbar,
        .button-inner {
            input {
            padding-inline-start: $filter-icon-space !important;
            }

            ion-icon {
            width: $filter-icon-width !important;
            margin-left: ($filter-icon-space - $filter-icon-width) * 0.5 !important;
            margin-right: ($filter-icon-space - $filter-icon-width) * 0.5 !important;
            left: 0 !important;
            }
        }

        .filter-item,
        .filter-item-search {
            --border-radius: 10px;
            border-radius: var(--border-radius);
            padding: 0;
            margin: 0;
            padding-inline-start: 0;
            padding-inline-end: 0;
            display: flex;
            background: var(--ion-color-light);
            color: var(--ion-color-light-contrast);
            height: 2.75em;

            overflow: hidden;

            > * {
                height: inherit !important;
                margin: 0;
                margin-inline: 0;

                &:first-child {
                    font-weight: normal;
                    flex-grow: 1;
                }
            }

            ion-button {
            --padding-start: 0;
            }

            .button-inner {
                text-align: left;
                width: 100%;
                display: flex;
                align-items: center;

                ion-icon {
                    width: $filter-icon-width !important;
                }

                > span {
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .remove-filter {
                        margin-right: -0.6em !important;
                        width: 1em !important;
                        font-size: 1.2em !important;
                    }
                }
            }
        }
    }
    .inner {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1em;
        font-size: .9em;

        @media(max-width: 990px) {
            font-size: .8em;
        }
        @media(max-width: 700px) {
            flex-direction: column
        }
        h4, p {
            padding: 0;
            margin: 0;
        }
        p {
            margin-top: .25em;
            color: var(--ion-color-medium);
        }
        .right {
            @media(min-width: 701px) {
                display: flex;
                align-items: center;
                flex-direction: column;
                align-items: flex-end;
            }

            @media(max-width: 700px) {
              gap:.5em;
                .date {
                    &:before {
                        content: '—';
                        margin: 0 .5em;
                        margin-top: 0;
                    }
                }
            }
        }
    }
    .raport-validated {
        color: var(--ion-color-success) !important;
        font-weight: bold;
    }
    .custom-height {
        min-height: initial;
    }


    .user-pictures {
      @media(max-width: 700px) {
        display: none;
      }

      $size: 2em;

      margin-top: 1em;

      display: flex;
      flex-direction: row-reverse;
      align-items: center;

      justify-content: flex-end;

      margin-left: $size*.2;

      img {
        width: $size;
        height: $size;
        border-radius: 50%;
        margin-left: -$size*.25;
        object-fit: cover;
        border: $size*.05 solid var(--background);
      }
    }
    .report-sheet-validation-status {
        padding: 0;
        list-style: none;

        @media(min-width: 500px) {
            display: flex;
        }
        li {
            padding: 6px 12px 6px 6px;
            color: #fff;
            border-radius: 10px;
            margin: 0 0 10px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 700;
            font-size: .8em;

            @media(min-width: 500px) {
                margin: 0 10px 0 0;
            }
            &:last-child {
                margin: 0 0 0 0;
            }
            .status {
                display: flex;
                align-items: center;
            }
            ion-icon {
                margin: 0 6px 0 0;
            }
            .user-initials-wrapper {
                margin: 0 0 0 12px;
            }

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
        }
        .waiting {
            background: var(--ion-color-warning);
        }
        .validated {
            background: var(--ion-color-success);
        }
    }
    .role-user-picture {
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 0.2em;
    }
    .user-initials-wrapper {
        display: flex;
        align-items: center;
        gap: 0.2em;
        margin: 0 0 0 12px;
        flex-shrink: 0;

        > span {
            flex-shrink: 0;
        }
    }
</style>